import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { openLoginPage, openSignupPage } from "../../utils";
import { useReactAppState } from "../../../shared/containers/utils";
import { trackUserFreemiumLoginWallViewed } from "../../../../libraries/_modules/tracking/helpers";

const RequiredAuthModal = ({
  visible = true,
  onGoBackClick = () => null,
  accountWall = null,
}) => {
  const { t, freemiumPopupImageUrl } = useReactAppState();
  const [modalElement, setModalElement] = useState(null);
  const accountWallSlugify = accountWall ? accountWall.toLowerCase().split(" ").join("_") : null;
  const accountWallPrefix = accountWallSlugify ? "aw_" + accountWallSlugify : "aw";
  useEffect(() => {
    const element = document.getElementById("react-root");
    setModalElement(element);
  }, []);

  useEffect(() => {
    if (visible) {
      trackUserFreemiumLoginWallViewed({
        freemiumType: "video",
      });
    }
  }, [visible])

  if (!modalElement) {
    return null;
  }

  return visible
    ? ReactDOM.createPortal(
        <div className="mls-c-video-wall">
          <div className="mls-c-video-wall-modal">
            {freemiumPopupImageUrl ? (
              <img src={freemiumPopupImageUrl} alt="freemium popup image" />
            ) : null}
            <div className="mls-c-video-wall-modal__container">
              <h2 className="mls-c-video-wall-modal__title">
                {t(`${accountWallPrefix}_hed_video`)}
              </h2>
              <button
                className="mls-c-video-wall-modal__button"
                onClick={openSignupPage}
              >
                {t(`${accountWallPrefix}_cta_1`)}
              </button>
              <div className="mls-c-video-wall-modal__account">
                <span>{t(`${accountWallPrefix}_dek_copy`)} </span>
                <a
                  className="mls-c-video-wall-modal__account--sign-in"
                  href="#"
                  onClick={openLoginPage}
                >
                  {t(`${accountWallPrefix}_cta_2`)}
                </a>
              </div>
              <div
                className="mls-c-video-wall-modal__go-back"
                onClick={onGoBackClick}
              >
                <span>{t(`${accountWallPrefix}_cta_3`)}</span>
              </div>
            </div>
          </div>
        </div>,
        modalElement,
      )
    : null;
};

export default RequiredAuthModal;
